import {createStyles} from '@material-ui/core';
import {Theme} from 'feedback-system/with-root/typedef';

const styles = (theme: Theme) => createStyles({
    user: {
        color: '#fff'
    },
    link: {
        textDecoration: 'none',
        color: theme.palette.text.primary
    },
    btn: {
        '&:hover': {
            background: 'transparent'
        }
    },
    avatar: {
        marginLeft: theme.spacing(1.5),
        width: 40,
        height: 40
    },
    avatarPreloader: {
        margin: '6px 8px',
        width: 40,
        height: 40
    },
    userName: {
        color: '#fff',
        maxWidth: '240px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textTransform: 'none',
        [theme.breakpoints.down('sm')]: {
            display: 'none'
        }
    },
    menu: {
        marginTop: '40px'
    }
});

export default styles;
